import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=12ce4413&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=12ce4413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce4413",
  null
  
)

export default component.exports